var A = Object.defineProperty;
var b = (e, t, o) => t in e ? A(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o;
var p = (e, t, o) => b(e, typeof t != "symbol" ? t + "" : t, o);
import v, { AxiosHeaders as y } from "axios";
import { NavigationClient as k, BrowserCacheLocation as C, PublicClientApplication as E, EventType as I } from "@azure/msal-browser";
import { ref as h, computed as R } from "vue";
import S from "loglevel";
class T extends k {
  constructor(o) {
    super();
    p(this, "router");
    this.router = o;
  }
  async navigateInternal(o, u) {
    const a = o.replace(window.location.origin, "");
    return u.noHistory ? this.router.replace(a) : this.router.push(a), !1;
  }
}
const i = S.getLogger("@simplifi/auth"), U = "identity-redirect-path";
let n = null, r = null, d = null;
const s = h(null), l = h({
  userId: "",
  userName: "",
  email: "",
  profilePictureThumbnailUrl: void 0,
  profilePictureUrl: void 0,
  roles: [],
  permissions: [],
  applications: [],
  claims: {}
});
async function f(e) {
  if (d == null)
    throw new Error(
      "Attempted to sign in before auth was initialized. Has init() been called?"
    );
  let t = d.apiBaseUri;
  t.endsWith("/") || (t += "/"), t.endsWith("api/") || (t += "api/"), t += e;
  const o = new y();
  return s.value && o.setAuthorization(`Bearer ${s.value}`), (await v.get(t, { headers: o })).data;
}
async function z(e) {
  d = e, i.debug("Initializing auth.");
  const t = await f(
    "authentication/configuration?target=User"
  );
  i.debug("Retrieved authentication config: ", t);
  const o = {
    auth: {
      clientId: t.clientId,
      authority: t.authority,
      knownAuthorities: [t.knownAuthority],
      redirectUri: `${window.location.protocol}//${window.location.host}/identity/callback`,
      navigateToLoginRequestUrl: !1
    },
    cache: {
      cacheLocation: C.LocalStorage,
      storeAuthStateInCookie: !1
    }
  };
  r = {
    scopes: [t.defaultScope]
  }, n = new E(o), await n.initialize(), i.debug("Initialized public client application");
  const u = new T(e.router);
  n.setNavigationClient(u);
  const a = n.getAllAccounts();
  a.length > 0 && (n.setActiveAccount(a[0]), i.debug("Set active account to", a[0])), n.addEventCallback((c) => {
    if (i.debug(
      "Received auth event",
      c.eventType,
      "with payload",
      c.payload
    ), c.eventType === I.LOGIN_SUCCESS && c.payload) {
      const g = c.payload.account;
      n.setActiveAccount(g), i.debug("Set active account to", g);
    }
  });
}
async function w(e = !1) {
  if (i.debug("Attempting sign in."), !n || !r)
    throw new Error(
      "Attempted to sign in before auth was initialized. Has init() been called?"
    );
  i.debug("Awaiting handle redirect promise."), await n.handleRedirectPromise();
  try {
    const t = n.getAllAccounts();
    return (e || !t.length) && (e ? i.debug("Forcing login redirect.") : i.debug("No accounts found."), localStorage.setItem(U, window.location.pathname), await n.loginRedirect(r), i.debug("Forcing login redirect.")), i.debug("Retrieving token."), await m();
  } catch (t) {
    return console.error(t), null;
  }
}
async function P() {
  if (i.debug("Attempting sign out."), !n || !r)
    throw new Error("Attempted to sign out before auth was initialized");
  const e = {
    account: n.getActiveAccount(),
    postLogoutRedirectUri: `${window.location.origin}/`
  };
  await n.logoutRedirect(e), i.debug("Signed out.");
}
async function m() {
  if (i.debug("Attempting to retrieve token."), !n || !r)
    throw new Error(
      "Attempted to sign in before auth was initialized. Has init() been called?"
    );
  if (!n.getActiveAccount())
    throw new Error("Attempted to get token with no active account.");
  try {
    const e = await n.acquireTokenSilent(r);
    return i.debug("Retrieved token silently."), e.accessToken !== s.value && (s.value = e.accessToken, l.value = await f("session")), s.value;
  } catch (e) {
    if (i.debug("Error retrieving token:", e), e instanceof Error && e.name === "InteractionRequiredAuthError")
      return i.debug("Attempting to force sign-in."), await w(!0);
    throw e;
  }
}
function $() {
  return {
    /**
     * Initializes the authentication client. Must be called prior to attempting user sign in.
     * @param config The config to use when configuring authentication.
     */
    init: z,
    /**
     * Attempts to sign the user in and retrieve an access token.
     * The `init` function must be called first.
     * @returns An access token if the sign in was successful, otherwise null.
     */
    signIn: w,
    /**
     * Signs the user out.
     * The `init` function must be called first.
     */
    signOut: P,
    /**
     * Retrieves an access token for the current user, and signs them in if necessary.
     * The `init` function must be called first.
     * @returns An access token if the user is signed in, otherwise null.
     */
    getToken: m,
    /**
     * True if the user is logged in, otherwise false.
     */
    loggedIn: R(() => !!l.value.userId),
    /**
     * Gets the user's information, including name, email, roles, claims, etc.
     */
    session: l,
    /**
     * Checks if the current user has the requested permission.
     * @param permission The permission to check for.
     * @returns True if the user has the permission, otherwise false.
     */
    hasPermission(e) {
      var t;
      return (t = l.value) == null ? void 0 : t.permissions.includes(e);
    }
  };
}
export {
  U as REDIRECT_PATH_STORAGE_KEY,
  $ as useAuth
};
